import { render, staticRenderFns } from "./grid-wo-items.vue?vue&type=template&id=1a8b9edb&scoped=true&"
import script from "./grid-wo-items.vue?vue&type=script&lang=js&"
export * from "./grid-wo-items.vue?vue&type=script&lang=js&"
import style0 from "./grid-wo-items.vue?vue&type=style&index=0&id=1a8b9edb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8b9edb",
  null
  
)

export default component.exports